export const classArray = [
  '1 клас',
  '2 клас',
  '3 клас',
  '4 клас',
  '6 клас',
  '5 клас',
  '7 клас',
  '8 клас',
  '9 клас',
  '10 клас',
  '11 клас',
  'ЗНО',
  'ЗНО поглиблений рівень',
  'Express course - Beginner',
  'Express course - Elementary',
  'Express course - Intermediate',
  'Express course - Pre-Intermediate',
  'Kids - Additional',
  'Kids - Advanced',
  'Kids - Beginner',
  'Kids - Elementary',
  'Kids - Intermidiate',
  'Kids - Pre-Intermidiate',
];
